import { useAxiosInterceptors } from "@/composables/useAxiosInterceptors";
import axios from "axios";
import type { AxiosRequestTransformer, AxiosResponseTransformer } from "axios";
import humps from "humps";

const instance = axios.create({
  timeout: 10000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  transformResponse: [
    ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
    (data) => humps.camelizeKeys(data),
  ],
  transformRequest: [
    (data) => humps.decamelizeKeys(data),
    ...(axios.defaults.transformRequest as AxiosRequestTransformer[]),
  ],
});

useAxiosInterceptors(instance);

export default instance;
